module.exports = __webpack_public_path__ + "media/assets/img/video/conversion-img-6f84bbff9c1282014a9ce540cc9a441f.svg";